<template>
  <div>
    <a-card class="policies-list-card">
      <a-row>
        <a-col>
          <div class="flex items-center justify-between mb-8">
            <h2 class="text-2xl ">Polizze</h2>
            <a-button @click="refresh" class="flex items-center">
              Aggiorna
              <a-icon type="sync" :spin="refreshing" :style="{ color: '#ed8936' }" />
            </a-button>
          </div>

          <div>
            <a-input-search
              placeholder="Cerca per codice o per email o nome e cognome"
              @search="val => (val != '' ? search(val, 'query') : search(undefined, 'query'))"
              :loading="searching"
              v-model="orderFilter"
              enterButton
            />

            <a-divider />
            <a-collapse v-model="activeKey">
              <a-collapse-panel
                class="font-bold"
                key="1"
                :header="
                  `FILTRI ` +
                    ($route.query.status ? `(` + $t('status.' + $route.query.status) + `)` : ``)
                "
              >
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                  <div
                    v-for="(s, index) in stats"
                    :key="index"
                    @click="
                      $route.query.status === s.status
                        ? search(undefined, 'status') /*clearSearch()*/
                        : search(s.status, 'status')
                    "
                    class="relative flex items-center justify-between px-4 py-4 border-2 rounded-lg cursor-pointer hover:border-i4m-orange"
                    :style="{
                      borderColor: $route.query.status === s.status ? '#ed8936' : ''
                    }"
                  >
                    <div class="flex flex-col mr-6">
                      <div class="mb-2 font-extrabold">{{ $t(`status.${s.status}`) }}</div>
                      <p class="h-10 mb-4 text-xs opacity-75 ">
                        {{ statusTooltips[s.status] || $t(`status.${s.status}`) }}
                      </p>
                    </div>
                    <span class="font-mono text-3xl font-bold">{{ s.count }}</span>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>

            <a-divider />

            <div class="flex items-center justify-between w-full">
              <div class="flex-grow">
                <a-button
                  @click="clearSearch"
                  v-if="!!activeQuery || $route.query.status || $route.query.reseller"
                  class="flex items-center"
                >
                  Pulisci filtri
                  <a-icon type="close" :style="{ color: '#ed8936' }" />
                </a-button>
              </div>

              <div class="flex items-center justify-between">
                <div class="mr-6" v-if="resellers.length > 0">
                  <label class="mr-2">Rivenditore:</label>
                  <a-select
                    v-model="resellerFilter"
                    @change="e => search(e, 'reseller')"
                    :allowClear="true"
                    style="width: 200px"
                    placeholder="Tutti"
                    show-search
                    :filter-option="filterResellers"
                  >
                    <a-select-option
                      :value="String(reseller.id)"
                      v-for="reseller in resellers"
                      :key="reseller.id"
                    >
                      {{ reseller.name }}
                    </a-select-option>
                  </a-select>
                </div>

                <label class="mr-2">Ordina:</label>

                <a-select defaultValue="created_at.desc" @change="val => search(val, 'sort')">
                  <a-select-option value="created_at.desc">
                    Dal più recente al più vecchio
                  </a-select-option>
                  <a-select-option value="created_at.asc">
                    Dal più vecchio al più recente
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <a-divider />

            <a-table
              :loading="gettingOrders"
              :pagination="paginationInfo"
              :columns="columns"
              :dataSource="orders"
              :rowKey="record => record.id"
            >
              <span slot="code" slot-scope="code, record">
                <span class="font-bold opacity-50">#</span>
                <span class="font-mono font-bold">{{ code }}</span>
                <div v-if="actionRequiredStatus.includes(record.status)">
                  <a-tag class="mt-2" color="red">Azione richiesta</a-tag>
                </div>
              </span>

              <span slot="status" slot-scope="status, record">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ statusTooltips[status] || $t(`status.${status}`) }}</span>
                  </template>
                  <a-tag :color="status == 'created' ? null : 'green'">
                    {{ $t(`status.${status}`) }}
                  </a-tag>
                </a-tooltip>

                <a-tag v-if="record.reseller" color="geekblue">
                  Rivenditore:{{ record.reseller.name }}
                </a-tag>
              </span>

              <span slot="customer" slot-scope="customer">
                {{ customer ? customer.name + ' ' + customer.surname : '' }}
                <div v-if="customer" class="opacity-60">{{ customer.email }}</div>
              </span>

              <span slot="offers" slot-scope="offers, record">
                <span v-if="offers.length > 0" class="flex flex-col">
                  <div class="flex items-center">
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>L'offerta è stata selezionata del cliente</span>
                      </template>
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        class="mr-3"
                        twoToneColor="#52c41a"
                      />
                    </a-tooltip>
                    <div class="flex flex-col">
                      <span class="mr-2 font-bold">
                        {{ offers[0].company.name }}
                        <span class="font-mono">{{ offers[0].value }}€</span>
                        <span class="font-normal opacity-75">
                          (tra {{ record.offers.length }}
                          {{ record.offers.length === 1 ? 'proposta' : 'proposte' }})
                        </span>
                      </span>
                      <div v-if="record.paid_on" class="flex items-center opacity-75">
                        pagata:
                        <div v-if="record.payment_method == 'scalapay'">
                          <scalapay-logo :width="80"></scalapay-logo>
                        </div>
                        <div v-else>carta di credito</div>
                      </div>
                    </div>
                  </div>
                </span>
                <span
                  class="flex items-center"
                  v-else-if="record.offers_status === 'success_no_offers'"
                >
                  <a-icon
                    type="exclamation-circle"
                    theme="twoTone"
                    class="mr-3"
                    twoToneColor="#eb2f96"
                  />
                  Nessuna offerta proposta
                </span>
                <div v-else-if="record.offers_status === 'generating'" class="flex items-center">
                  <a-icon type="loading" class="mr-2" />
                  Offerte in generazione...
                </div>

                <span v-else-if="record.offers.length">
                  {{ record.offers.length }}
                  {{ record.offers.length > 1 ? ' Offerte proposte' : ' Offerta proposta' }}
                </span>
              </span>

              <span slot="created_at" slot-scope="created_at">{{ created_at | humanizeDate }}</span>

              <span slot="detail" slot-scope="text, record">
                <router-link
                  :to="{
                    name: 'broker-order',
                    params: { id: record.id },
                    query: { fromList: true }
                  }"
                >
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Vai al dettaglio polizza</span>
                    </template>

                    <a-icon :style="{ fontSize: '24px', color: '#ed8936' }" type="eye" />
                  </a-tooltip>
                </router-link>
              </span>

              <span slot="delete" slot-scope="text, record">
                <a-popconfirm
                  title="Vuoi cancellare questo ordine?"
                  @confirm="deleteOrder(record.id)"
                  okText="Sì"
                  cancelText="No"
                  placement="left"
                >
                  <a-icon
                    :style="{ fontSize: '24px', color: 'red' }"
                    :type="ordersDeleting[record.id] ? 'loading' : 'delete'"
                  />
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
// import BrokerOrdersList from '@/components/BrokerOrdersList.vue';
import api from '@/api.js';
import Vue from 'vue';
import moment from 'moment';
import _ from 'underscore';
import 'moment/locale/it';

export default {
  name: 'UserPolicies',
  components: {},
  watch: {},

  data: function() {
    return {
      activeKey: 0,
      statusTooltips: {
        created: 'Un utente anonimo ha aggiunto strumenti al carrello',
        questionnaire_completed:
          "L'utente ha completato il questionario per tutti gli strumenti, ma non ha ancora fornito i dati di contatto",
        offer_chosen: "L'utente ha scelto un offerta",
        contract_proposal_sent:
          "L'utente ha ricevuto la proposta di contratto e deve caricare le perizie degli strumenti",
        approval_neeeded: "L'utente ha caricato le perizie ed è in attesa della approvazione."
      },

      columns: [
        {
          dataIndex: 'code',
          key: 'code',
          title: 'Codice',
          scopedSlots: { customRender: 'code' }
        },
        {
          title: 'Stato',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: 'Cliente',
          key: 'customer',
          dataIndex: 'customer',
          scopedSlots: { customRender: 'customer' }
        },
        {
          title: 'Offerta',
          key: 'offers',
          dataIndex: 'offers',
          scopedSlots: { customRender: 'offers' }
        },
        {
          title: 'Creato il',
          key: 'created_at',
          dataIndex: 'created_at',
          scopedSlots: { customRender: 'created_at' },
          sorter: false
        },
        {
          title: '',
          key: 'detail',
          scopedSlots: { customRender: 'detail' }
        },
        {
          title: '',
          key: 'delete',
          scopedSlots: { customRender: 'delete' }
        }
      ],

      stats: [],

      gettingOrders: true,
      paginationInfo: {},
      orders: [],

      resellers: [],

      ordersDeleting: {},

      resellerFilter: null,

      searching: false,
      refreshing: false,

      // filters
      orderFilter: null,

      actionRequiredStatus: ['approval_neeeded', 'policies_needed']
    };
  },

  mounted: async function() {
    api.getResellers({ per_page: 999999 }).then(resp => {
      this.resellers = resp.data.data;
    });

    const q = this.$router.currentRoute.query;
    await this.getBrokerOrders({
      ...q,
      page: q.page || 1
    });
    await this.getStats();

    this.resellerFilter = q.reseller;
    this.orderFilter = q.query;
  },

  filters: {
    humanizeDate(value) {
      return moment
        .utc(value)
        .local()
        .format('DD MMMM YYYY H:mm');
    }
  },

  computed: {
    activeQuery() {
      return this.$route.query.query;
    }
  },

  methods: {
    filterResellers(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    clearSearch() {
      this.getBrokerOrders();
      this.orderFilter = '';
      this.resellerFilter = null;
      this.$router.push({ name: this.$route.name });
    },

    async refresh() {
      if (this.refreshing) return false;
      const q = this.$router.currentRoute.query;
      this.refreshing = true;
      await this.getBrokerOrders(q);
      await this.getStats();
      this.refreshing = false;
    },

    async search(value, key = 'query') {
      const q = this.$router.currentRoute.query;

      this.searching = true;
      const query = {
        ...q,
        page: 1,
        [key]: value
      };

      await this.getBrokerOrders(query);

      this.$router.push({ name: this.$route.name, query: query });
      this.activeKey = 0;
      this.searching = false;
    },

    async deleteOrder(id) {
      if (this.ordersDeleting[id]) return;

      Vue.set(this.ordersDeleting, id, true);
      await api.deleteBrokerOrder(id);
      const q = this.$router.currentRoute.query;
      // console.log(q);
      await this.getBrokerOrders(q);
      await this.getStats();
      Vue.set(this.ordersDeleting, id, false);
    },

    async getStats() {
      const res = await api.getBrokerOrdersCounters();
      let arrStats = [
        'created',
        'questionnaire_completed',
        'profiled',
        'no_offers',
        'offers',
        'offer_chosen',
        'contract_proposal_needed',
        'contract_proposal_sent',
        'approval_neeeded',
        'approved',
        'policies_needed',
        'paid_failed',
        'policies_emitted',
        'active'
      ];
      let arrMap = arrStats.map(stat => stat);
      this.stats = res.data
        .filter(stat => arrStats.includes(stat.status))
        .sort(function(a, b) {
          return _.invert(arrMap)[a.status] - _.invert(arrMap)[b.status];
        });
    },

    async getBrokerOrders(query) {
      this.gettingOrders = true;
      try {
        var resp = await api.getBrokerOrders(query);
        this.$store.commit('setBrokerLoggedIn', true);
      } catch (error) {
        if (error.response.status === 401) {
          try {
            await api.refreshToken();
            resp = await api.getBrokerOrders(query);
            this.$store.commit('setBrokerLoggedIn', true);
          } catch (e) {
            // console.log('could not refresh the token');
            this.$router.replace({ name: 'broker-login' });
          }
        }
      }

      this.gettingOrders = false;

      this.orders = resp.data.data;
      this.mapPaginationParams({ ...resp.data, data: null, query: query });
    },

    mapPaginationParams(laravelPaginationData) {
      // console.log(laravelPaginationData);
      const { current_page, per_page, total, query } = laravelPaginationData;
      this.paginationInfo = {
        onChange: page => {
          this.getBrokerOrders({ ...query, page: page });
          this.$router.push({ name: this.$route.name, query: { ...query, page } });
        },
        current: current_page,
        pageSize: per_page,
        total,
        showTotal: total => `${total} ordini totali`
      };
    }
  }
};
</script>
<style lang="scss">
.order-row {
  display: grid;
  grid-template-columns: 8rem 0.5fr 1fr 1fr 1fr 6rem 2rem;
  grid-column-gap: 10px;
  grid-template-rows: auto;
  grid-template-areas: 'orderid orderstatus ordercustomer orderoffers orderdate ordershow orderdelete';
  align-items: center;

  .order-id {
    grid-area: orderid;
  }

  .orderstatus {
    grid-area: orderstatus;
  }

  .order-show {
    grid-area: ordershow;
  }

  .order-customer {
    grid-area: ordercustomer;
  }

  .order-offers {
    grid-area: orderoffers;
  }

  .order-delete {
    grid-area: orderdelete;
  }

  .order-date {
    grid-area: orderdate;
    justify-self: end;
  }
}
</style>
